import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import './TextInput.styles.css';
import {TextInputProps} from './TextInput.props';
import { TextField } from "@mui/material";


export const TextInput: React.FC<TextInputProps> = ({
  width,
  height,
  typeInput,
  placeholderInput,
  borderColor = '',
  nameInput,
  borderRadius,
  padding = '0 16px',
  margin = 0,
  isDisabled= false,
  color,
  fontWeight,
  fontSize,
  onChangeInput = () => {},
  onKeyDownEvent,
  value,
  onFocusEvent,
  inputRef,
}) => {
  const [inputValue, setInputValue] = useState('');
  useEffect(() =>{
    setInputValue(value)
  },[value])
  const handleTextInputValue= (event:ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    onChangeInput && onChangeInput(event.target.value)
  }

  return (
    <input className='text-input-style' ref={inputRef} onKeyDown={onKeyDownEvent} onChange={handleTextInputValue} onPointerDown={onFocusEvent} disabled={isDisabled} value={inputValue} type={typeInput} placeholder={placeholderInput} name={nameInput} style={{ width, height, borderRadius, borderColor, padding, margin, color,fontWeight,fontSize }}/>
  );
};
